import { useDatabaseContent } from '@databases/database-state';
import { defaultStoreUtils } from '@databases/redux';
import { type DatabaseField, DatabaseFieldType } from '@databases/types/database';
import { getJiraColumnTypeFromState } from '@databases/utils/database/field-types/jiraIssueDetails';
import { selectJiraIssues } from '@databases/utils/redux/jira/selectors';

/**
 * Resolves the Jira column type string for a Jira issue details field
 *
 * Returns `undefined` if the field is not Jira issue details type, or if
 * the Jira column type cannot be determined.
 */
export const useJiraFieldColumnType = (
  field: DatabaseField | undefined
): string | undefined => {
  const { contentId } = useDatabaseContent();

  return defaultStoreUtils.useEqualSelector((state) => {
    if (!field || field.type !== DatabaseFieldType.JIRA_ISSUE_DETAILS || !contentId) {
      return undefined;
    }

    const jiraIssues = selectJiraIssues(state);

    return getJiraColumnTypeFromState(
      field as DatabaseField<DatabaseFieldType.JIRA_ISSUE_DETAILS>,
      jiraIssues
    );
  });
};
